declare global {
	interface Window {
		env: any;
	}
}

export const environment = {
	production: false,
	clientId: window['env']?.['clientId'] || '2d927b51-bb39-4e29-8502-03f094fea3ee',
	authority: window['env']?.['authority'] || 'https://login.microsoftonline.com/f530c72b-e2d4-46a4-b9de-e55f0b2131da',
	audience: window['env']?.['audience'] || 'https://volvogroupqa.onmicrosoft.com/2d927b51-bb39-4e29-8502-03f094fea3ee/',
	redirectUri: window['env']?.['redirectUri'] || location.origin,
	scope: window['env']?.['scope'] || 'user_impersonation',
	backEndApiUrl: window['env']?.['backEndApiUrl'] || 'https://tco-api.azurewebsites.net',
	businessApplicationAccessUrl:
		window['env']?.['businessApplicationAccessUrl'] ||
		'https://volvoitsm.service-now.com/sp?id=sc_cat_item&sys_id=605bf3288711f8d064270fe60cbb35cd',
	customerServicePortalUrl: window['env']?.['customerServicePortalUrl'] || 'https://volvoitsm.service-now.com/csm',
	connectionString:
		window['env']?.['connectionString'] ||
		'InstrumentationKey=21fec0af-adef-4994-86ec-0b10e9e1408f;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
};
